import {useMediaQuery} from "react-responsive";
import logo_ov from "../img/logo_optovision.png";

function Logo({theme}) {
    const primaryColor = '#00833E'
    const secondaryColor = '#FFFFFF'

    const isMobile = useMediaQuery({ maxWidth: 576 }); // Define el ancho máximo para considerar como móvil
    const width = isMobile ? 'w-[350px]' : 'w-[450px]'
    const height = isMobile ? 'h-[80px]' : 'h-[150px]'
    if (theme === 'mimetika-web') {
        console.log('original logo')

        return (
            <div className={` ${width} ${height} relative custom-logo`}>
                <SvgLogo className="absolute w-full" color={primaryColor} bgColor={secondaryColor} />
                <SvgLogo className="absolute w-full clip-circle animate-clip-circle" color={secondaryColor} bgColor={primaryColor} />
            </div>
        );
    }
    else if (theme === 'mimetika-web-ov'){
        return (
            <div className={`${width} ${height} relative custom-logo`}>
        <img
          className="w-full h-full object-contain"
          src={logo_ov}
          alt="Optovision Logo"
        />
      </div>
        );
        
    }
    else {
        console.log('no logo')

        return (
            <div/> // return empty div till other logos are defined
        );
    }
}

function SvgLogo({color, bgColor, className }){
    return (
        <div className={className} style={{backgroundColor: bgColor}}>
        <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg"
             x="0px" y="0px"
             viewBox='0 400 1000 200'>
            <g>
	<g>
		<polygon fill={color} points="353.7,438.9 353.7,527.4 258.2,438.9 234,438.9 190.6,438.9 190.6,561.4 234,561.4 234,473
			329.4,561.4 353.7,561.4 397.1,561.4 397.1,438.9 		"/>
        <rect x="101.9" y="438.9" fill={color} width="44.6" height="122.5"/>
        <path fill={color} d="M486.5,476.5h65.2c5.2,0,10.4,0.1,15.6,0.1c5,0.1,10.1,0.8,15,1.9c11.3,2.5,17.2,10.1,17.1,21.6
			c0.1,11.4-5.8,19.1-17.1,21.6c-4.9,1.1-10,1.8-15,1.9c-5.2,0.1-10.3,0.1-15.5,0.2h-65.4L486.5,476.5L486.5,476.5z M602.2,442.2
			c-11.8-3.3-21.9-3.3-36.2-3.3H441.9v122.5H566c14.3,0,24.3,0,36.2-3.3c27.7-7.7,42.5-29.4,42.5-57.9v-0.1
			C644.7,471.6,629.8,449.9,602.2,442.2"/>
	</g>
                <path fill={color} d="M786.6,434.4c11.5,0.5,23.3,0.7,35.1,1.5c11.8,0.8,23.5,2.6,34.8,6.5c9.6,3.4,18.3,8.3,25.6,15.6
		c8.4,8.5,13.2,18.7,15.2,30.4c1.5,9.3,1.1,18.5-1,27.6c-3,12.8-9.7,23.2-20.1,31.2c-8.1,6.2-17.3,10.2-27.2,12.7
		c-8.4,2.1-16.9,3.5-25.5,4.2c-22.5,1.8-45.1,1.6-67.6,0.6c-12.1-0.6-24.2-2.1-35.9-5.6c-9-2.7-17.3-6.6-24.7-12.4
		c-11.8-9.4-18.5-21.8-20.5-36.7c-1.2-8.3-0.9-16.6,0.9-24.8c3.1-14.5,10.8-25.8,22.9-34.2c8.1-5.6,17.2-9.2,26.7-11.4
		c9.2-2.2,18.5-3.5,28-3.9C764.2,435.2,775.2,434.9,786.6,434.4L786.6,434.4z M785.8,529.9c0,0,0,0.1,0,0.1c4.5,0,9,0,13.4,0
		c7.2,0,14.4-0.2,21.5-1.2c4.9-0.7,9.8-1.6,14.5-3.3c4.3-1.6,7.9-4.1,11.1-7.4c10.2-10.7,11.4-33.5-8.1-42.3c-3-1.4-6.3-2.3-9.5-3.1
		c-7-1.8-14.2-2.3-21.4-2.4c-13.3-0.3-26.5-0.4-39.8-0.1c-6.5,0.1-13.1,0.9-19.6,1.7c-5.4,0.6-10.7,2.1-15.5,4.7
		c-6.2,3.3-10.6,8.1-12.6,15c-1.2,4-1.5,8.2-0.9,12.4c1,8.1,4.9,14.4,12,18.7c3.3,2,6.9,3.4,10.6,4.3c7.6,1.9,15.4,2.7,23.3,2.9
		C771.7,530,778.7,529.9,785.8,529.9L785.8,529.9z"/>
</g>
</svg>
        </div>
    );
}

export default Logo;
